import { createSlice } from '@reduxjs/toolkit';
import { api } from '../api';

export const calculatedPriceSlice = createSlice({
	name: 'calculatedPrice',
	initialState: {
		calculatedPrice: {},
		calculatingPrice: false,
	},
	extraReducers: (builder) => {
		builder
			.addMatcher(api.endpoints.onGetCalculatedPrice.matchPending, (state) => {
				state.calculatingPrice = true;
			})
			.addMatcher(api.endpoints.onGetCalculatedPrice.matchFulfilled, (state, { payload }) => {
				state.calculatedPrice = {...payload, ...state.calculatedPrice};
				state.calculatingPrice = false;
			})
			.addMatcher(api.endpoints.onGetCalculatedPrice.matchRejected, (state) => {
				state.calculatingPrice = false;
			});
	},
});

export default calculatedPriceSlice.reducer;